import { ThemeProvider } from "@mui/material/styles";
import { BrowserRouter as Router } from "react-router-dom";
import { theme } from "@web-applications/allinga-web-components";
import Notification from "shared/containers/Notification";
import ErrorNotification from "shared/containers/ErrorNotification";
import { runtimeConfig } from "@/shared/config/runtime-config-loader";
import AppRoutes from "./app.routes";
import "i18n/config";

function App(): JSX.Element {
  return (
    <ThemeProvider theme={theme}>
      <main>
        <Router basename={runtimeConfig.baseHref}>
          <AppRoutes />
        </Router>
        <Notification />
        <ErrorNotification />
      </main>
    </ThemeProvider>
  );
}

export default App;
